// 관리자 판정 (웹 화면 표시용) — 보안 P0-3, 2026-09-15
// 이 값은 메뉴·화면을 보여줄지 정할 뿐, 실제 권한은 서버(CF lib/admin-auth.js)와 firestore.rules 가 판정한다.
// 우선순위: Firebase Auth 커스텀 클레임 admin:true (userData.adminClaim — App.js/AuthContext 가 토큰에서 채움)
// 전환기 폴백: users 문서 isAdmin/role — 서버·rules 폴백 제거일(목표 2026-10-01)에 함께 제거한다.

/** 로그인 사용자 토큰의 admin 클레임. 실패하면 false (기록 남김). */
export async function fetchAdminClaim(firebaseUser) {
    if (!firebaseUser || typeof firebaseUser.getIdTokenResult !== 'function') return false;
    try {
        const result = await firebaseUser.getIdTokenResult();
        return result?.claims?.admin === true;
    } catch (e) {
        console.warn('[adminClaim] 토큰 클레임 조회 실패 — 폴백 판정 사용:', e?.message);
        return false;
    }
}

/** 화면 게이트용 관리자 여부 */
export function isAdminUser(userData) {
    if (!userData) return false;
    if (userData.adminClaim === true) return true;
    // ↓ 전환기 폴백 (제거 예정)
    return userData.isAdmin === true || userData.role === 'admin';
}
